var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.523,
    height: 17.581,
    viewBox: "0 0 13.523 17.581",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-lock",
    "data-name": "Icon ionic-ios-lock",
    d: "M18.583,9.46H17.569V7.487a4.057,4.057,0,1,0-8.114-.055V9.46H8.44a1.7,1.7,0,0,0-1.69,1.69v8.114a1.7,1.7,0,0,0,1.69,1.69H18.583a1.7,1.7,0,0,0,1.69-1.69V11.151A1.7,1.7,0,0,0,18.583,9.46ZM14.1,14.734v2.908a.606.606,0,0,1-.562.609.592.592,0,0,1-.621-.592V14.734a1.352,1.352,0,1,1,1.183,0ZM16.385,9.46H10.638V7.432a2.874,2.874,0,0,1,5.747,0Z",
    transform: "translate(-6.75 -3.374)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.1c2b5f0ff706eb588696b4730fe43c4c.svg";
export { ForwardRef as ReactComponent };